/**
 * Open/close state for the ⌘K Command Center. Global (not component state) so
 * the header pill, the keyboard listener and any future "search this" buttons
 * can all drive the same dialog.
 */
import { create } from 'zustand';

interface CommandCenterState {
    readonly isOpen: boolean;
    open: () => void;
    close: () => void;
    toggle: () => void;
}

export const useCommandCenterStore = create<CommandCenterState>((set) => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
    toggle: () => set((s) => ({ isOpen: !s.isOpen })),
}));
